import n from "react";
import { forwardRef as B, useStyleConfig as S, useTheme as _, Button as E, Text as l } from "@chakra-ui/react";
import { Icon as s } from "../icon/icon.js";
import "@loadable/component";
const $ = (r) => {
  const t = {
    ".default-image": { display: "none" },
    ".active-image": { display: "block" }
  };
  return {
    baseStyle: ({ theme: e }) => ({
      display: "flex",
      alignItems: "center",
      alignContent: "center",
      background: "transparent",
      borderRadius: 0,
      padding: 0,
      border: 0,
      borderBottom: `2px solid ${e.action.tertiaryDefault}`,
      ...e.menu.defaultButton,
      svg: {
        height: e.menu.defaultIcon,
        width: e.menu.defaultIcon
      },
      ".bag-count": {},
      "&.masthead-active .end-icon": {
        transform: "rotate(180deg)"
      }
    }),
    variants: {
      dark: ({ theme: e }) => {
        const a = {
          color: e.menu.lightSelected,
          borderBottom: `2px solid ${e.border.onPrimary}`,
          ".bag-count": {
            ...e.menu.emphasizedButton
          },
          ...t
        }, o = r ? e.border.onPrimary : e.action.tertiaryDefault;
        return {
          color: e.menu.lightDefault,
          _hover: {
            color: e.menu.lightHover,
            borderBottom: `2px solid ${o}`,
            ...t
          },
          _focus: "",
          _active: "",
          "&.masthead-active": a
        };
      },
      light: ({ theme: e }) => {
        const a = {
          color: e.menu.selected,
          borderBottom: `2px solid ${e.border.accent1}`,
          ".bag-count": {
            ...e.menu.emphasizedButton
          },
          ...t
        }, o = r ? e.border.accent1 : e.action.tertiaryDefault;
        return {
          color: e.menu.default,
          _hover: {
            color: e.menu.hover,
            borderBottom: `2px solid ${o}`,
            ...t
          },
          _focus: "",
          _active: "",
          "&.masthead-active": a
        };
      }
    }
  };
}, N = B(
  ({
    startIcon: r,
    endIcon: t,
    children: e,
    iconFill: a,
    boxSize: o,
    bagCount: i,
    showCount: d = !1,
    active: u,
    variant: m = "light",
    className: g = "",
    ...c
  }, p) => {
    const f = "aria-expanded" in c, b = S(null, {
      variant: m,
      styleConfig: $(f)
    }), { menuExtraSmallInnerSpacing: y, menuSmallInnerSpacing: v } = _(), x = d && i > 0;
    return /* @__PURE__ */ n.createElement(
      E,
      {
        sx: b,
        className: `${g}${u ? " masthead-active" : ""}`,
        ref: p,
        ...c
      },
      r && /* @__PURE__ */ n.createElement(
        s,
        {
          as: r,
          color: a,
          boxSize: o,
          className: "start-icon",
          role: "img",
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ n.createElement(l, { py: y }, e),
      x && /* @__PURE__ */ n.createElement(
        l,
        {
          as: "span",
          className: "bag-count",
          pl: {
            base: "initial",
            lg: v
          }
        },
        "(",
        i,
        ")"
      ),
      t && /* @__PURE__ */ n.createElement(
        s,
        {
          as: t,
          color: a,
          boxSize: o,
          className: "end-icon",
          role: "img",
          "aria-hidden": "true"
        }
      )
    );
  }
);
export {
  N as MastheadButton
};
